<template>
  <div v-if="client">
    <pin-list ref="pinList" :data-func="loadPins" />
  </div>
</template>

<script>
  import pinList from '../common/pin-list.vue';

  import state from '../../state';
  import pinService from '../../services/pin.service';
  import currencyService from '../../services/currency.service';
  import utils from '../../utils';

  import { required, minValue } from 'vuelidate/lib/validators';

  export default {
    name: 'client-pins',
    components: { pinList },
    data() {
      return {
        newPinVisible: false,
        newPin: {
          value: 0,
          currency: null,
          branch: null,
          description: null
        },
        newPinsCount: 1,
        downloadPins: true
      }
    },
    computed: {
      client() {
        return state.client.get();
      },
      currencies() {
        return state.currencies.get();
      }
    },
    validations: {
      newPin: {
        value: {
          required,
          minValue: minValue(0.01)
        },
        currency: {
          required
        }
      }
    },
    async mounted() {
      await this.$refs.pinList.load();
    },
    methods: {
      async loadPins(filter) {
        return await pinService.getByClient(filter);
      },
      getSourcePinValue() {
        return currencyService.toSource(this.newPin.value, this.newPin.currency);
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/client/pins.vue